import Breadcrumb from "../../Component/Breadcrumb";

function VisionMission() {
  return (
    <>
      <Breadcrumb>About / Vision Mission</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>OUR VISION & VALUES</h1>
            </div>

            <div className="row">
              {/* Vision Section */}
              <div className="col-lg-6 col-md-12">
                <div className="vision-card p-4 rounded-4 shadow-sm h-100">
                  <h4 className="vision-heading mb-3">
                    <i className=" me-2 text-primary"></i> Our Vision
                  </h4>
                  <ul className="modern-list">
                    <li>
                      Integral development — physical, intellectual, mental, and
                      spiritual — of every child enrolled here.
                    </li>
                    <li>
                      To make them responsible, broad-minded, patriotic, and
                      disciplined citizens of the country.
                    </li>
                    <li>
                      To make our children committed to the service of God and
                      of the nation.
                    </li>
                    <li>
                      To instill compassion, unselfish service, dedication to
                      duty, love for others, and a thirst for excellence.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Values Section */}
              <div className="col-lg-6 col-md-12">
                <div className="values-card p-4 rounded-4 shadow-sm h-100">
                  <h4 className="values-heading mb-3">
                    <i className=" me-2 text-danger"></i> Our Values
                  </h4>
                  <ul className="modern-list">
                    <li>
                      Recognize and encourage talents and foster appreciation
                      for the creative ability of every child.
                    </li>
                    <li>Stimulate and satisfy intellectual curiosity.</li>
                    <li>
                      Develop a caring school community that values empathy and
                      respect.
                    </li>
                    <li>
                      Encourage collaboration, leadership, and initiative among
                      students.
                    </li>
                    <li>
                      Offer high-quality education and rich learning
                      opportunities for holistic growth.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default VisionMission;
